export const buttonStyle = (variant: string) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
})
